

export enum AdvancedAnalysisWizardStepType {

    InputData = "Input Data",
    AdvancedAnalysisConfig = "Advanced Analysis"

}